// Initialization for @stitch-fix/i18n.
//
// Also provides region-based feature checks, via `setRegion` and `featureIsAvailable`.
//
// USAGE:
//
//    import { loadTranslations } from '../i18n';
//    import translations from './translations.json';
//
//    const { useTranslation } = loadTranslations(translations, 'MyComponent');
//
//    const MyComponent = ({ region }) => {
//      const { t } = useTranslation();
//      setRegion(region)
//      featureIsAvailable('inspiration');
//
//      t('hello.world');
//    }

import { A } from '@mobily/ts-belt';
import { initI18n } from '@stitch-fix/i18n';
import { Region } from '../constants';
import { regionalFeatures } from './regionalFeatures';
import { translations } from './translations';

const { loadTranslations } = initI18n();

const { useTranslation } = loadTranslations(translations, 'KnitShared');

let region: Region = 'US';

const setRegion = (newRegion: Region) => {
  region = newRegion;
};

const getRegion = () => {
  return region;
};

const resetRegion = () => {
  setRegion('US');
};

const featureIsAvailable = (feature: string) => {
  const r = getRegion();

  return A.includes(regionalFeatures[r], feature);
};

export {
  featureIsAvailable,
  getRegion,
  loadTranslations,
  resetRegion,
  setRegion,
  useTranslation as useSharedTranslation,
};
